module.exports = __webpack_public_path__ + "img/link-banner-tw.718cdef1.png";